import React, { useEffect, useState } from 'react';

import classes from "./SearchBar.module.css";
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters.png'
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from 'primereact/radiobutton';
import { ListBox } from 'primereact/listbox';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import DataManager from '../../hooks/DataManager';

const SearchBar = (props) => {
  const { placeholder, onChange, value, handleFocus, handleBlur, setSort, sortBy, setSortBy, categoryFilter, setCategoryFilter, showFilterButton, reset} = props;
  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([])
  const [filterType, setFilterType] = useState("Ascending")
  const [selectedSorts, setSelectedSorts] = useState("")

  const dataManager = new DataManager();

  const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
          event.preventDefault();
      }
  };

  const handleClear = () => {
      onChange({ target: { value: '' } }); // Mimics native input event
  };

  const handleShowFilters = () => {
    setShowFilters(prev => !prev);
  };

  const HandleResetFilters = () => {
    setSelectedFilter([])
    setFilterType("Ascending")
    setSelectedSorts("")

    setSortBy([])
    setCategoryFilter([])

    //Doesnt update the form, will still have the data from previous search upon opening - find way to reset form too

    setShowFilters(false)
  }


  useEffect(() => {
    if (reset > 0){
      HandleResetFilters()
    }
  }, [reset])

  const HandleApplyFilters = () => {
    let updatedSelectedCategories = [];
    let updatedSortBy = [];

    if (selectedSorts.includes("Online")) {
      updatedSelectedCategories.push("Online");
    }
    
    if (selectedSorts.includes("Offline")) {
      updatedSelectedCategories.push("Offline");
    }
    
    if (selectedSorts.includes("No portal site name")) {
      updatedSelectedCategories.push("No site name");
    }
    
    if (updatedSelectedCategories.length === 0) {
      updatedSelectedCategories.push("all");
    } 
    
    switch (selectedFilter){
      case "Site name" : {
        switch (filterType) {
          case "Ascending" : {
            updatedSortBy.push("Site name - Asc")
            break;
          }
          case "Descending" : {
            updatedSortBy.push("Site name - Desc")
            break;
          }
        }
        break;
      }
      case "Firmware" : {
        switch (filterType) {
          case "Ascending" : {
            updatedSortBy.push("Firmware - Asc")
            break;
          }
          case "Descending" : {
            updatedSortBy.push("Firmware - Desc")
            break;
          }
        }
        break;
      }
      case "User count" : {
        switch (filterType) {
          case "Ascending" : {
            updatedSortBy.push("User Count - Asc")
            break;
          }
          case "Descending" : {
            updatedSortBy.push("User Count - Desc")
            break;
          }
        }
        break;
      } 
    }

    console.log(updatedSelectedCategories)
    console.log(updatedSortBy)
    setCategoryFilter(updatedSelectedCategories);
    setSortBy(updatedSortBy)
    setShowFilters(false)
  }

  const options = [
    "Site name",
    "Firmware",
    "User count"
  ]

  const sorts = [
    "Online",
    "Offline", 
    "No portal site name"
  ]

  return (
      <div className={classes.searchContainer}>
          <input
              className={classes.searchBar}
              placeholder={placeholder}
              value={value}
              onKeyPress={handleKeyPress}
              onChange={onChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              spellCheck={false}
          />

          <div className={classes.buttonGroup}>
              {value && (
                  <button className={classes.clearButton} onClick={handleClear} type="button">
                      ×
                  </button>
              )}
              { showFilterButton && <button className={classes.filterButton} onClick={handleShowFilters} type="button">
                  <img style={{ height: '30px', width: '30px' }} src={filters}/>
              </button>}
          </div>

          {showFilters && (
                <div className={classes.filterDropdown}>
                  
                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Sort by:</label>
                        <Dropdown
                            value={selectedFilter}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setSelectedFilter(e.value)}
                            options={options}
                            placeholder="Sorting method"
                            checkmark
                            highlightOnSelect
                        />
                    </div>

                  <div className={classes.filterType}> 
                    <div className="flex gap-4 mt-3">
                        <RadioButton
                          style={{marginRight:"5px"}} 
                          inputId="asc"
                          name="sortOrder"
                          value="Ascending"
                          onChange={(e) => setFilterType(e.value)}
                          checked={filterType === 'Ascending'}
                        />
                        <label style={{marginRight:"20px"}} htmlFor="asc" className="ml-2">Ascending</label>

                        <RadioButton
                          style={{marginRight:"5px"}} 
                          inputId="desc"
                          name="sortOrder"
                          value="Descending"
                          onChange={(e) => setFilterType(e.value)}
                          checked={filterType === 'Descending'}
                        />
                        <label htmlFor="desc" className="ml-2">Descending</label>
                    </div>
                  </div>

                  <br></br>
                  <br></br>
                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Filter:</label>
                        <MultiSelect 
                          value={selectedSorts} 
                          onChange={(e) => setSelectedSorts(e.value)} 
                          options={sorts} 
                          placeholder="Select filters" 
                          className="w-full md:w-14rem"
                          style={{ width: '400px' }} />
                    </div>

                    <br></br>

                    <div className={classes.buttonRow}>
                      <Button  type="button" style={{marginRight:"15px"}} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger'/>
                      <Button  type="button" label="Search" onClick={HandleApplyFilters}/>
                    </div>
                </div>
            )}
      </div>
  );
};

export default SearchBar